import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetDeviceConfigSettingTableData: '[GetDeviceConfigSettingTableData] Action',
  SetDeviceConfigSettingData: '[SetDeviceConfigSettingData] Action',
  GetDeviceConfigSettingTranslateData: '[GetDeviceConfigSettingTranslateData] Action',
  GetDeviceConfigTabTranslateData: '[GetDeviceConfigTabTranslateData] Action',
  GetDeviceConfigButtonTranslateData: '[GetDeviceConfigButtonTranslateData] Action',
  GetDeviceConfigCloudSoloTranslateData: '[GetDeviceConfigCloudSoloTranslateData] Action',
}

const initialDeviceConfigSettingState: IDeviceConfigSettingState = {
  deviceConfigSettingColumnList: [],
  deviceConfigSettingColumnValues: [],
  deviceConfigSettingDefinitions: [],
  deviceConfigSettingColumnNames: [],
  deviceConfigSettingDataTypes: [],
  deviceConfigSettingDe: [],
  deviceConfigSettingEn: [],
  deviceConfigTabDe: [],
  deviceConfigTabEn: [],
  deviceConfigButtonDe: [],
  deviceConfigButtonEn: [],
  deviceConfigCloudSoloDe: [],
  deviceConfigCloudSoloEn: [],

  tabList: [],
  buttonsList: [],
  cloudsoloList: [],

  deviceConfigSettingsOptions: []
}

export interface IDeviceConfigSettingState {
  deviceConfigSettingColumnValues: [],
  deviceConfigSettingColumnList: [],
  deviceConfigSettingDefinitions: []
  deviceConfigSettingColumnNames: [],
  deviceConfigSettingDataTypes: [],
  deviceConfigSettingDe: [],
  deviceConfigSettingEn: [],
  deviceConfigTabDe: [],
  deviceConfigTabEn: [],
  deviceConfigButtonDe: [],
  deviceConfigButtonEn: [],
  deviceConfigCloudSoloDe: [],
  deviceConfigCloudSoloEn: [],

  tabList: [],
  buttonsList: [],
  cloudsoloList: [],

  deviceConfigSettingsOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-DeviceConfigSetting', whitelist:  [ ] },
  (state: IDeviceConfigSettingState = initialDeviceConfigSettingState, action: any) => {
    switch (action.type) {
      case actionTypes.GetDeviceConfigSettingTableData: {
        const deviceConfigSettingColumnValues = JSON.parse(action.payload.data.deviceConfigSettings);
        let headers = JSON.parse(action.payload.data.headers);
        let deviceConfigSettingDefinitions = JSON.parse(action.payload.data.definitions);
        let tabHeaders = JSON.parse(action.payload.data.tabHeaders); 
        let buttonHeaders = JSON.parse(action.payload.data.buttonHeaders); 
        let cloudsoloHeaders = JSON.parse(action.payload.data.cloudsoloHeaders); 
        let deviceConfigSettingColumnNames = action.payload.data.columnNames;
        let deviceConfigSettingDataTypes = action.payload.data.dataTypes;
        let deviceConfigSettingColumnList: any = [];
        let tabList: any = [];
        let buttonsList: any = [];
        let cloudsoloList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          deviceConfigSettingColumnList.push(newElement[0]);
        });
        buttonHeaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          buttonsList.push(newElement[0]);
        });
        tabHeaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          tabList.push(newElement[0]);
        });
        cloudsoloHeaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          cloudsoloList.push(newElement[0]);
        });
        
        return { ...state, deviceConfigSettingColumnList, deviceConfigSettingColumnValues, deviceConfigSettingDefinitions, deviceConfigSettingDataTypes , deviceConfigSettingColumnNames, tabList, buttonsList, cloudsoloList};
      }
    
      case actionTypes.SetDeviceConfigSettingData: {
        const deviceConfigSettingColumnValues = action.payload.data;
        return { ...state, deviceConfigSettingColumnValues };
      }

      case actionTypes.GetDeviceConfigSettingTranslateData: {
        const deviceConfigSettingDe = JSON.parse(action.payload.data.de);
        const deviceConfigSettingEn = JSON.parse(action.payload.data.en);
        return { ...state, deviceConfigSettingDe, deviceConfigSettingEn };
      }

      case actionTypes.GetDeviceConfigTabTranslateData: {
        const deviceConfigTabDe = JSON.parse(action.payload.data.de);
        const deviceConfigTabEn = JSON.parse(action.payload.data.en);
        return { ...state, deviceConfigTabDe, deviceConfigTabEn };
      }

      case actionTypes.GetDeviceConfigButtonTranslateData: {
        const deviceConfigButtonDe = JSON.parse(action.payload.data.de);
        const deviceConfigButtonEn = JSON.parse(action.payload.data.en);
        return { ...state, deviceConfigButtonDe, deviceConfigButtonEn };
      }

      case actionTypes.GetDeviceConfigCloudSoloTranslateData: {
        const deviceConfigCloudSoloDe = JSON.parse(action.payload.data.de);
        const deviceConfigCloudSoloEn = JSON.parse(action.payload.data.en);
        return { ...state, deviceConfigCloudSoloDe, deviceConfigCloudSoloEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getDeviceConfigSettingTableData: (data: any) => ({ type: actionTypes.GetDeviceConfigSettingTableData, payload: { data } }),
  getDeviceConfigTabTranslateData: (data: any) => ({ type: actionTypes.GetDeviceConfigTabTranslateData, payload: { data } }),
  getDeviceConfigButtonTranslateData: (data: any) => ({ type: actionTypes.GetDeviceConfigButtonTranslateData, payload: { data } }),
  getDeviceConfigCloudSoloTranslateData: (data: any) => ({ type: actionTypes.GetDeviceConfigCloudSoloTranslateData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetDeviceConfigSettingTranslateData, payload: { data } }),
  setDeviceConfigSettingData: (data: any) => ({ type: actionTypes.SetDeviceConfigSettingData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
